import { render, staticRenderFns } from "./SiteMemeberCard.vue?vue&type=template&id=190c85c8"
import script from "./SiteMemeberCard.vue?vue&type=script&lang=js"
export * from "./SiteMemeberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports